import CXMApiClient from "../CXMApiClient";
function initialState() {
  return {
    ConfirmationModalInfo: {
      showModal: false,
      modalBodyMessage: null,
      modalHeaderMessage: null,
      modalActionConfirmBtnName: null,
      modalActionRejectBtnName: null,
      requestParameters: null,
      confirmationActionMethodName: null,
      type: null
    },
    ReassignTaskConfirmationModalInfo: {
      showModal: false,
      modalBodyMessage: null,
      modalHeaderMessage: null,
      modalActionConfirmBtnName: null,
      modalActionRejectBtnName: null,
      requestParameters: null,
      confirmationActionMethodName: null,
      type: null
    },
    UnwindModalInfo: {
      showModal: false,
      data: null,
      pageType: null
    },
    ConfirmationModalSpinner : false
  };
}

const state = initialState();

const getters = {};

const actions = {
  updateConfirmationModalInfo: function(context, data) {
    context.commit("updateConfirmationModalInfo", data);
  },
  updateConfirmationModalSpinner(context, data){
    context.commit("updateConfirmationModalSpinner", data);
  },
  closeConfirmationModal: function(context) {
    context.commit("closeConfirmationModal");
  },
  updateReassignTaskConfirmationModalInfo: function(context, data) {
    context.commit("updateReassignTaskConfirmationModalInfo", data);
  },
  closeReassignTaskConfirmationModal: function(context) {
    context.commit("closeReassignTaskConfirmationModal");
  },
  updateUnwindModalInfo(context, data) {
    context.commit("updateUnwindModalInfo", data);
  }
};

const mutations = {
  updateConfirmationModalInfo: function(state, data) {
    state.ConfirmationModalInfo = data;
  },
  closeConfirmationModal: function(state) {
    state.ConfirmationModalInfo.showModal = false;
    state.ConfirmationModalInfo.modalBodyMessage = null;
    state.ConfirmationModalInfo.modalHeaderMessage = null;
    state.ConfirmationModalInfo.modalActionConfirmBtnName = null;
    state.ConfirmationModalInfo.modalActionRejectBtnName = null;
    state.ConfirmationModalInfo.requestParameters = null;
    state.ConfirmationModalInfo.confirmationActionMethodName = null;
    state.ConfirmationModalInfo.type = null;
  },
  updateReassignTaskConfirmationModalInfo: function(state, data) {
    state.ReassignTaskConfirmationModalInfo = data;
  },
  closeReassignTaskConfirmationModal: function(state) {
    state.ReassignTaskConfirmationModalInfo.showModal = false;
    state.ReassignTaskConfirmationModalInfo.modalBodyMessage = null;
    state.ReassignTaskConfirmationModalInfo.modalHeaderMessage = null;
    state.ReassignTaskConfirmationModalInfo.modalActionConfirmBtnName = null;
    state.ReassignTaskConfirmationModalInfo.modalActionRejectBtnName = null;
    state.ReassignTaskConfirmationModalInfo.requestParameters = null;
    state.ReassignTaskConfirmationModalInfo.confirmationActionMethodName = null;
    state.ReassignTaskConfirmationModalInfo.type = null;
  },
  updateUnwindModalInfo(state, data) {
    state.UnwindModalInfo = data;
  },
  updateConfirmationModalSpinner(state, data){
    state.ConfirmationModalSpinner = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/SharedActions.js